module.exports = __webpack_public_path__ + "media/hyper/images/layouts/layout-3-8676c89b66903d979815b81734bbd241.png";